var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "modal-guide modal-guide-open-tag",
      attrs: {
        name: _vm.modalName,
        "show-close": false,
        "cover-closeable": false,
        "close-btn-handler": _vm.handleCloseBtn,
      },
      on: { modalClose: _vm.handleCloseBtn },
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          attrs: { slot: "modal-content" },
          slot: "modal-content",
        },
        [
          _c("div", { staticClass: "guide-body", class: { show: _vm.show } }, [
            _c("div", { staticClass: "guide-content" }, [
              _vm._v("打开高德地图查看原文"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "guide-footer" }, [
              _c(
                "div",
                {
                  staticClass: "guide-btn",
                  on: { click: _vm.handleCancelBtn },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "guide-btn", on: { click: _vm.openAmap } },
                [
                  _c(
                    "WXLaunchBtn",
                    {
                      attrs: { schema: _vm.schema },
                      on: {
                        error: _vm.handleWxLunchBtnError,
                        wxClick: _vm.handleWxClick,
                      },
                    },
                    [
                      _c("template", { slot: "default" }, [
                        _c(
                          "div",
                          {
                            staticClass: "open-btn-in",
                            attrs: { id: "openBtn" },
                            on: { click: _vm.callNativeAmap },
                          },
                          [_vm._v("打开")]
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v("\n        继续\n      "),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }